module.exports = __webpack_public_path__ + "media/images/svg/logo_2-18807317b892ce11856572912b2ad816.svg";